var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"header-section flex items-center text-base font-normal mr-4 ml-2 cursor-pointer text-woot-500 dark:text-woot-500",on:{"!click":function($event){return _vm.goBack.apply(null, arguments)}}},[_c('fluent-icon',{attrs:{"icon":"chevron-left"}}),_vm._v("\n  "+_vm._s(_vm.buttonLabel || _vm.$t('GENERAL_SETTINGS.BACK'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }